import InfiniteScroll from 'react-infinite-scroll-component';

import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { getContainerHeight } from '../Messages/utils';

import { MessagesSkeleton } from '../Shared/skeletons';

const MessagesTemplateListComponent = (props) => {
  const {
    chats,
    loadNextMessages,
    nextMessages,
    isLoading,
    MessageTemplateListItem,
  } = props;

  const { t } = useTransl();
  const height = getContainerHeight();

  return (
    <InfiniteScroll
      dataLength={chats.length}
      next={() => loadNextMessages()}
      hasMore={nextMessages}
      height={height}
      style={{ minWidth: '31rem' }}
      loader={
        chats.length === 0 ? (
          Array.from({ length: 10 }).map((v, i) => <MessagesSkeleton key={i} />)
        ) : (
          <MessagesSkeleton />
        )
      }
      endMessage={
        chats.length === 0 && isLoading ? (
          <MessagesSkeleton />
        ) : chats.length === 0 ? (
          <Typography align="center">
            <b>{t('messages.noTreads')}</b>
          </Typography>
        ) : (
          ''
        )
      }
    >
      <Box display="flex" flexDirection="column">
        {chats?.map((thread) =>
          thread?.id ? (
            <MessageTemplateListItem
              key={thread?.id}
              thread={thread}
              {...props}
            />
          ) : null,
        )}
      </Box>
    </InfiniteScroll>
  );
};

MessagesTemplateListComponent.defaultProps = {
  nextMessages: null,
};

MessagesTemplateListComponent.propTypes = {
  chats: PropTypes.instanceOf(Object).isRequired,
  loadNextMessages: PropTypes.func.isRequired,
  nextMessages: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool.isRequired,
  MessageTemplateListItem: PropTypes.instanceOf(Object).isRequired,
};

export default MessagesTemplateListComponent;
